import { Box, Rating } from "@mui/material";

const Ratings = () => {
	return (
		<Box>
			<Rating name="half-rating" defaultValue={2.5} precision={0.5}/>
			<Rating name="half-rating-read" defaultValue={2.5} precision={0.5} readOnly/>
			<Rating name="size-small" defaultValue={2} size="small"/>
			<Rating name="size-medium" defaultValue={2}/>
			<Rating name="size-large" defaultValue={2} size="large"/>
		</Box>
	)
}

export default Ratings